import React from 'react';
import CommonSVGIcon, { Props } from './CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 60 60">
      <path d="M30.0355 29.1372C37.7752 29.1372 44.3432 22.6991 44.3432 14.3695C44.3432 6.23894 37.7396 0 30.0355 0C22.2959 0 15.6568 6.3385 15.6923 14.4358C15.6923 22.6991 22.2604 29.1372 30.0355 29.1372ZM7.88166 60H52.1183C57.9763 60 60 58.3407 60 55.2876C60 46.7589 48.426 35.0111 30 35.0111C11.6095 35.0111 0 46.7589 0 55.2876C0 58.3407 2.02367 60 7.88166 60Z"/>
    </CommonSVGIcon>
  );
}
